module.exports = __webpack_public_path__ + "static/media/sheworks_logo_wo_tag.cbeaac25.png";